import { styled } from '@linaria/react';

function Fraction({ numerator, denominator }) {
  return (
    <Wrapper>
      <Numerator style={{ right: numerator > 0 ? '20%' : '0%' }}>
        {numerator}
      </Numerator>
      {numerator > 0 && (
        <>
          <Slash />
          <Denominator>{denominator}</Denominator>
        </>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  --height: 5rem;
  position: relative;
  width: 3rem;
  height: var(--height);
`;

const Numerator = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 20%;
  height: calc(var(--height) * 0.5);
  display: flex;
  justify-content: center;
  font-size: calc(var(--height) * 0.4);
`;

const Denominator = styled.span`
  position: absolute;
  top: calc(var(--height) * 0.525);
  left: 25%;
  right: 0;
  display: flex;
  justify-content: center;
  font-size: calc(var(--height) * 0.25);
`;

const Slash = styled.div`
  position: absolute;
  top: 52%;
  left: 0px;
  right: 0px;
  width: 80%;
  height: 2px;
  margin: auto;
  border-radius: 1000px;
  transform: rotate(-20deg);
  background-color: var(--color-text);
`;

export default Fraction;
